var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',[_c('EditImageModal',{ref:"modal",attrs:{"title":_vm.translate('forms.label.image')}}),_c('Hoverlay',{on:{"click":_vm.edit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }